class LocationSerializer {
  static deSerialize(data) {
    return {
      id: data.Key,
      name: data.Value,
    };
  }
}

export { LocationSerializer };



// WEBPACK FOOTER //
// ./src/networking/serializers/LocationSerializer.js